"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSbApiError = void 0;

var _unescape = _interopRequireDefault(require("lodash/unescape"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _errorFactory = require("./error-factory");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var propertyMap = {
  type: 'msg_type',
  subType: 'msg_subtype',
  what: 'msg_what'
};

var createDetailObject = function createDetailObject(message) {
  return _defineProperty({}, propertyMap.what, message);
};
/**
 * @desc
 * Creates a SbApiError to describe API error received from backend.
 *
 * @param  {Object} apiError Error object received from backend.
 * @return {Object}          SbApiError object.
 */


var createSbApiError = function createSbApiError(apiError) {
  if (apiError === undefined) {
    throw Error('createSbApiError::argument "apiError" must be defined');
  }

  var namespace = apiError.namespace,
      reason = apiError.reason;
  var detail = apiError.detail;

  if (detail) {
    if ((0, _isString.default)(detail)) {
      var detailParsed = (0, _unescape.default)(detail);
      var matched = detailParsed.match(/^.*?: .*?: (.*)$/);

      if (matched) {
        var _matched$slice = matched.slice(1),
            _matched$slice2 = _slicedToArray(_matched$slice, 1),
            body = _matched$slice2[0];

        try {
          detail = JSON.parse(body);
        } catch (e) {
          // In some cases 'body' part is the pure string containing message, so don't fail here.
          detail = createDetailObject(body);
        }
      } else {
        // Backend is in some cases returning reason (what) in 'detail' property (string),
        // so create detail object instead of throwing 'Unparsable' error.
        detail = createDetailObject(detail);
      }
    }

    Object.keys(propertyMap).forEach(function (key) {
      if (Object.prototype.hasOwnProperty.call(detail, propertyMap[key])) {
        detail[key] = detail[propertyMap[key]];
      }
    });
    var message = detail.msg_what || _constants.SB_API_ERROR_DEFAULT_MESSAGE;
    var error = (0, _errorFactory.errorFactory)(_constants.SB_API_ERROR, message, _objectSpread({
      reason: reason,
      namespace: namespace
    }, detail));
    return error;
  }

  return (0, _errorFactory.errorFactory)(_constants.SB_API_ERROR, reason, {
    reason: reason,
    namespace: namespace
  });
};

exports.createSbApiError = createSbApiError;
//# sourceMappingURL=create-sb-api-error.js.map